export const MY_BILLS_PAGE_TAB_LABEL = {
  BANKSLIPS: 'Faturas abertas',
  INVOICES: 'Notas fiscais',
  PAID: 'Histórico de Pagamento',
}
